/**
 * Zod ohne JIT (Nachtrag N-csp-zod, RW-E-15). Zod 4 prüft beim ersten Objekt-Schema mit `new Function('')`, ob es Code
 * erzeugen darf, und fällt bei einem Verbot still auf die langsamere Prüfung zurück. Unter der Content-Security-Policy
 * des Dashboards (`script-src 'self'`, ohne `unsafe-eval`) meldet der Browser aber schon diese Probe als Verstoß
 * (`script-src eval`). Mit `jitless` entfällt die Probe, und die Richtlinie bleibt streng.
 *
 * Die Einstellung gilt global (`globalThis.__zod_globalConfig`) und damit auch für die Schemas aus
 * `@socialfy/api-contract`. Dieses Modul muss deshalb der allererste Import von `main.tsx` sein, vor dem ersten Schema.
 */
import { z } from 'zod';

z.config({ jitless: true });
